@import "~@govbr-ds/core/src/components/divider/divider";
@import "~@govbr-ds/core/src/partial/scss/configs/grid";
@import "~@govbr-ds/core/src/partial/scss/utilities/flexbox";
@import "~@govbr-ds/core/src/components/footer/footer";
@import "~@govbr-ds/core/src/components/footer/mixins";
@include footer-social;

:host {
  display: block;
  width: 100%;
}

.br-footer {
  display: flex;
  flex-flow: column nowrap;

  &.inverted {
    --background: var(--background-light);

    @include light-mode;
  }
}

.site-map {
  display: flex;
  flex-flow: column nowrap;
  padding: var(--footer-padding-bottom);
}

.social-and-partners {
  display: none;
  padding: var(--footer-padding-bottom);
}

.social-newtwork,
.partners {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}

.social-title {
  flex-basis: 100%;
}

@media (width >= 576px) {
  .social-and-partners {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-end;
  }
}

@media (width >= 992px) {
  .site-map {
    flex-flow: row wrap;
    justify-content: flex-start;
  }
}
